import React from "react";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { OG_IMAGE_TYPES, OGImage } from "../og-image";

const VasCmsMetaTags = ({
    history,
    cmsDetails = {},
    isSeoEnabled = true
}) => {

    const baseUrl = `${appUrl()}/`;
    const pageUrl = `${appUrl()}${history.location.pathname.replace(/\/$/, "")}/`;

    const { metaTitle = "", metaDescription = "" } = cmsDetails || {};

    return (
        <React.Fragment>
            <Helmet>
                <title>{metaTitle}</title>
                <meta name="title" content={metaTitle} />
                <meta name="description" content={metaDescription} />
                <meta name="ROBOTS" content={isSeoEnabled ? "INDEX,FOLLOW" : "NOINDEX,NOFOLLOW"} />
                <meta property="og:title" content={metaTitle} />
                <meta property="og:description" content={metaDescription} />
                <meta property="og:url" content={`${pageUrl}`} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="CARS24" />
                <link href={pageUrl} rel="canonical" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta property="twitter:domain" content={`${baseUrl}`} />
                <meta property="twitter:url" content={pageUrl} />
                <meta name="twitter:title" content={metaTitle} />
                <meta name="twitter:description" content={metaDescription} />
            </Helmet>
            <OGImage type={OG_IMAGE_TYPES.pdi} />
        </React.Fragment>
    );
};

VasCmsMetaTags.propTypes = {
    history: PropTypes.object,
    cmsDetails: PropTypes.object,
    isSeoEnabled: PropTypes.bool
};

export default withRouter(VasCmsMetaTags);

